// ──────────────────────────────────────────────────────────────────────────
// L'ORDINE DELLE SCHEDE DEL PROFILO
//
// Il maestro mette le schede del profilo nell'ordine che gli serve: chi
// guarda prima i Compensi li porta in cima. Si spostano quelle in mezzo; i
// Primi passi restano in cima (spariscono da soli quando sono fatti) e la
// Guida, I tuoi dati e inCampo restano in fondo (non si guardano ogni
// giorno).
//
// L'ordine è un elenco di colonne: una sul telefono, due sul PC, dove le
// schede stanno affiancate e ognuna scende per conto suo. Resta sul
// dispositivo, come il tema: sul telefono si vogliono in cima i numeri del
// giorno, sul PC conta come stanno nelle due colonne, e un ordine non deve
// rompere l'altro.
// ──────────────────────────────────────────────────────────────────────────

export const PROFILE_CARDS = [
	"hours",
	"earnings",
	"payments",
	"players",
	"courts",
	"absences",
	"school",
	"conditions",
	"account",
]

export const DEFAULT_LAYOUTS = {
	phone: [PROFILE_CARDS],
	// a sinistra e a destra più o meno la stessa altezza: i Compensi e gli
	// Allievi, i più lunghi, uno per parte
	pc: [
		["hours", "payments", "courts", "school", "account"],
		["earnings", "players", "absences", "conditions"],
	],
}

const STORAGE_KEY = "incampo.profileCards"
const storageKey = kind => `${STORAGE_KEY}.${kind}`

// Quello che arriva dal dispositivo può essere vecchio o rotto: si tengono le
// schede che esistono, una volta sola, e quelle nuove (che chi ha salvato
// l'ordine non aveva) vanno dove starebbero di partenza.
export const sanitizeLayout = (stored, fallback) => {
	if (
		!Array.isArray(stored) ||
		stored.length !== fallback.length ||
		!stored.every(Array.isArray)
	)
		return fallback

	const seen = new Set()
	const columns = stored.map(column =>
		column.filter(id => {
			if (!PROFILE_CARDS.includes(id) || seen.has(id)) return false
			seen.add(id)
			return true
		}),
	)
	fallback.forEach((column, c) =>
		column.forEach((id, i) => {
			if (seen.has(id)) return
			columns[c].splice(Math.min(i, columns[c].length), 0, id)
			seen.add(id)
		}),
	)
	return columns
}

// `index` è il posto nella colonna d'arrivo, contato senza la scheda che si
// sposta
export const moveCard = (layout, id, column, index) => {
	const columns = layout.map(ids => ids.filter(other => other !== id))
	const target = columns[column]
	target.splice(Math.max(0, Math.min(index, target.length)), 0, id)
	return columns
}

export const findCard = (layout, id) => {
	const column = layout.findIndex(ids => ids.includes(id))
	return { column, index: column < 0 ? -1 : layout[column].indexOf(id) }
}

export const sameLayout = (a, b) => JSON.stringify(a) === JSON.stringify(b)

export const readLayout = kind => {
	const fallback = DEFAULT_LAYOUTS[kind]
	try {
		return sanitizeLayout(JSON.parse(window.localStorage.getItem(storageKey(kind))), fallback)
	} catch {
		return fallback
	}
}

export const writeLayout = (kind, layout) => {
	try {
		// l'ordine di partenza non si salva: se un giorno cambia, chi non
		// ha mai spostato niente riceve quello nuovo
		if (sameLayout(layout, DEFAULT_LAYOUTS[kind]))
			window.localStorage.removeItem(storageKey(kind))
		else window.localStorage.setItem(storageKey(kind), JSON.stringify(layout))
	} catch {
		// senza memoria l'ordine dura finché l'app è aperta: pazienza
	}
}
